/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import mbpLogger from 'mbp-logger';
import { string } from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';

import { setEnterpriseCalendarSalesForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Actions';
import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';

const EnterpriseCalendarABTest = ({ pageType }) => {
    const dispatch = useDispatch();
    const enterpriseCalendarSaleForceABTestData = useSelector((state) => state?.mfeCheckout?.app?.abTest?.enterpriseCalendar || {});

    const { loading, data, error } = useSalesforcePersonalizedContentQuery({
        interactionName: 'All-Checkout-Enterprise Calendar-v1',
        targeting: { pageType },
        featureFlag: true,
        apolloOptions: {
            fetchPolicy: 'cache-first',
        },
    });

    if ((loading) || (!loading && !data && !error)) {
        return <></>;
    }

    if (error) {
        mbpLogger.logError({
            function: 'EnterpriseCalendarABTest',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            message: 'Enterprise Calendar Salesforce AB test returned an error',
            jsError: error,
        });
    }

    if (
            data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup
            && data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup !== enterpriseCalendarSaleForceABTestData?.campaign?.campaignResponses?.[0]?.userGroup
    ) {
        dispatch(setEnterpriseCalendarSalesForceABTest(data.contentSF));
    }

    return <></>;
};

EnterpriseCalendarABTest.propTypes = {
    pageType: string.isRequired,
};

export default EnterpriseCalendarABTest;
